export default __webpack_public_path__ + "static/132-fcd972ae5c9b6600bf3186943ecf71f1.jpg";